import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import MatchStats from './pages/MatchStats';
import TableView from './pages/TableView';
import TeamPerformance from './pages/TeamPerformance';
import TeamComparison from './pages/TeamComparison';
import WorldCup from './pages/WorldCup';
import NotFound from './pages/NotFound';
import theme from './theme';
import { DataProvider } from './context/DataContext';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: {
            backgroundColor: '#B4D4FF',
            margin: 0,
            padding: 0,
          },
        }}
      />
      <DataProvider>
        <Router>
          <Box
            display="flex"
            flexDirection="column"
            minHeight="100vh"
          >
            <Header />
            <Box component="main" flexGrow={1}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/stats" element={<MatchStats />} />
                <Route path="/table" element={<TableView />} />
                <Route path="/performance" element={<TeamPerformance />} />
                <Route path="/comparison" element={<TeamComparison />} />
                <Route path="/world" element={<WorldCup />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </Router>
      </DataProvider>
    </ThemeProvider>
  );
};

export default App;
